export default {
  processing: false,
  error: null,
  success: null,
}
